export const TEST_ID = 'johnDeereExportModalFooter';
